export default "__VITE_ASSET__BmgG0bH4__"